<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar compra"
             col-md="col-md-5" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label><strong>Fornecedor: <span class="text-danger font-bold">*</span></strong></label>
              <p class="font-bold"> {{ dado.fornecedor_exibicao }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="vendedor" v-model="dado.vendedor" size="small" style="width: 100%" autofocus/>
                <label for="vendedor"><strong>Vendedor: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_compra" v-model="dado.data_compra" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataCompra" dateFormat="dd/mm/yyyy"
                            :invalid="campoVazio.includes('data_compra')" />
                <label for="data_compra"><strong>Data Compra: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="valor_total" v-model="dado.valor_total" size="small" style="width: 100%"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"
                             :invalid="campoVazio.includes('valor_total')"/>
                <label for="valor_total"><strong>Valor Total: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="observacao" v-model="dado.observacao" size="small" style="width: 100%"/>
                <label for="observacao"><strong>Observação: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, denormalizeDates, normalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";
import moment from "moment/moment";


export default {
  name: "EditarCompra",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
    fornecedorDesc: String,
  },
  emits: ["fechar", "atualizarDados"],
  data() {
    return {
      dado: 1,
      erro: null,
      campoVazio: [],
    }
  },
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.compras.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
        normalizeDates(this.dado, ['data_compra']);
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      denormalizeDates(this.dado, ['data_compra']);
      const resultado = await apiRequest("PATCH", apiUrl.compras.retrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        ['data_compra', 'fornecedor'].forEach(field => {
          if (field === 'fornecedor') {
            resultado.data[field] = this.dado.fornecedor_exibicao;
          } else {
            resultado.data[field] = moment(resultado.data[field]).format('DD/MM/YYYY');
          }
        });
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
    Inputmask("99/99/9999").mask(this.$refs.dataCompra.$el.querySelector("input"));
  },
}
</script>
